<template>
  <component-wrapper>
    <grid-container-fi>
      <div class="fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-12">
        <div class="video-fi">
          <video-player-fi
            :aspect-ratio="videoImageRatio"
            :fields="fields"
          />
        </div>
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script>
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import GridContainerFi from 'components/grid-fi/GridContainerFi';
import VideoPlayerFi from 'components/video-player-fi/VideoPlayerFi';

export default {
  name: 'VideoFi',
  components: {
    ComponentWrapper,
    GridContainerFi,
    VideoPlayerFi,
  },
  inject: ['fields'],
  computed: {
    videoImageRatio() {
      if (this.fields.image?.value?.width && this.fields.image?.value?.height) {
        return this.fields.image.value.width / this.fields.image.value.height;
      }

      // set 16 / 9 ratio default if image width & height are missing
      return 16 / 9;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './video-fi';
</style>
